<template>
  <div :class="`alert alert-${color}`">
    <i v-if="icon" :class="`icon-${icon}`"> </i>
    <span> {{ getReferencelabel(message) }} </span>
  </div>
</template>
<script>

import { getReferencelabel } from '@/mixins/utils';

export default {
  props: {
    message: {
      type: String,
      default: 'My message'
    },
    color: {
      type: String,
      default: 'success'
    },
    icon: {
      type: String,
      default: ''
    }
  },
  setup () {
    return { getReferencelabel };
  }
};
</script>
<style>
.alert{
 border-radius: 5px;
 padding: 1rem;
 display: flex;
 font-weight: bold;
 color: white;
}

.alert i {
  font-size: 20px;
  padding-right: 1rem;
}

.alert-success{
  background-color: green;
  border: 1px solid lightgreen;
}

.alert-error{
  background-color: red;
  border: 1px solid lightcoral;
}
</style>
